var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8762 6.02411C14.57 5.8986 15.2786 6.14764 15.7413 6.67959L16.9145 8.02835C17.3772 8.5603 17.5256 9.29657 17.3052 9.96625L16.343 12.8893C16.2304 13.2313 16.0275 13.5366 15.7558 13.773L7.89797 20.6079C7.06456 21.3328 5.80129 21.2448 5.07637 20.4114L1.83722 16.6875C1.1123 15.8541 1.20026 14.5908 2.03367 13.8659L9.89154 7.03097C10.1632 6.79464 10.4937 6.63605 10.8481 6.57194L13.8762 6.02411Z",
    stroke: "#718596"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9569,
    cy: 10.2861,
    r: 2.03081,
    transform: "rotate(-41.0173 12.9569 10.2861)",
    stroke: "#718596"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2616 5.95211C18.1072 5.39177 19.5731 3.94149 18.6724 2.62305",
    stroke: "#718596",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeals);
export default __webpack_public_path__ + "static/media/deals.8624d241209c930806419ba1d115428d.svg";
export { ForwardRef as ReactComponent };